$(document).ready(function() {
	if(!document.querySelector('.GPC0049')) return false;

	var $target = $('.GPC0049 .drag-area');
	$target.twentytwenty({
		no_overlay: true
	}).each(function(){
		var $this = $(this);
		var dragTitle = $this.data('handle-title');
		$this.find('.twentytwenty-handle').attr('title',dragTitle)
			.end().find('.twentytwenty-before')
			//.add($this.find('.twentytwenty-before').siblings('.title-area:first'))
			.add($this.find('.twentytwenty-before').siblings('.info-text:first'))
			.wrapAll('<div class="img-wrapper"></div>')
			.end().end().find('.twentytwenty-after')
			//.add($this.find('.twentytwenty-after').siblings('.title-area'))
			.add($this.find('.twentytwenty-after').siblings('.info-text'))
			.wrapAll('<div class="img-wrapper"></div>');
	});

	var $obj = $('.GPC0049');
	var waNumber = 0;
	$obj.each(function() {
		var $target;
		if($(this).find('.title') && !$(this).find('.title').is(':empty')) {
			$target = $(this).find('.title');
		}
		if($target) {
			$target.attr('id', 'waGPC0049_'+waNumber);
			$(this).find('a.btn').attr('aria-describedby', 'waGPC0049_'+waNumber);
			$(this).find('a.link-text').attr('aria-describedby', 'waGPC0049_'+waNumber);
			waNumber++;
		}
	});
});